'use strict'

module.exports = {
    showPassword: function () {
        $('img.hide').on('click', function () {
            $(this).siblings('input').attr('type') === 'password' ?
                $(this).siblings('input').attr('type', 'text') :
                $(this).siblings('input').attr('type', 'password');
        });
    }
}
